export const ERROR_FIELD_NAME_COLLECTION = {
  BRAND: 'brand',
  AT_LEAST_GTIN_UPC: 'at least upc/gtin',
};
